import { createMutation } from '../common';
import * as apis from '../apis';

export const useCreateCriticalEvent = createMutation({
  mutationFn: apis.postCriticalEvent,
});

export const useUpdateCriticalEvent = createMutation({
  mutationFn: apis.putCriticalEvent,
});

export const useDeleteCriticalEvent = createMutation({
  mutationFn: apis.deleteCriticalEvent,
});

export const useQueryCriticalEvent = createMutation({
  mutationFn: apis.queryCriticalEvent,
});
